import { useContext, useState } from 'react';
import { ApiRoutes } from 'routes/routeConstants/apiRoutes';
import axiosInstance from 'interceptor/axiosInstance';
import { Helpdesk } from 'models/Helpdesk/helpdesk.model';
import { HelpDeskContext } from 'context/HelpDeskContext';

const HelpdeskService = (
  setHelpDeskDataCallback?: (data: Helpdesk | null) => void
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [fetchedHelpDeskData, setFetchedHelpDeskData] =
    useState<Helpdesk | null>(null);
  const { setHelpDeskLoading } = useContext(HelpDeskContext);

  const fetchData = async (params?: { 'input-field': string }) => {
    try {
      setLoading(true);
      setHelpDeskLoading(true);

      const response = await axiosInstance.get(ApiRoutes.HELPDESK, {
        params,
      });
      const helpdeskData = response.data.helpdesk;
      setFetchedHelpDeskData(helpdeskData);
      if (setHelpDeskDataCallback) {
        setHelpDeskDataCallback(helpdeskData);
      }
    } catch (error) {
      console.log('Error fetching company:', error);
    } finally {
      setLoading(false);
      setHelpDeskLoading(false);
    }
  };

  const clearHelpDeskData = () => {
    setFetchedHelpDeskData(null);
    if (setHelpDeskDataCallback) {
      setHelpDeskDataCallback(null);
    }
  };

  return {
    fetchData,
    fetchedHelpDeskData,
    loading,
    clearHelpDeskData,
  };
};

export default HelpdeskService;
